var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useSpring } from '@react-spring/core';
import React, { useMemo, useState } from 'react';
import { animated } from '@react-spring/web';
import cx from 'classnames';
import { Container } from './styles';
const springConfig = { mass: 1, tension: 210, friction: 26, precision: 0.01, velocity: 0 };
export const Input = (_a) => {
    var { style, className, prefix, size } = _a, props = __rest(_a, ["style", "className", "prefix", "size"]);
    const [focus, setFocus] = useState(false);
    const [selfValue, setSelfValue] = useState(props.defaultValue);
    const handleChange = (e) => {
        var _a;
        setSelfValue(e.target.value);
        (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e);
    };
    const isControlled = 'value' in props;
    const controlledValue = useMemo(() => {
        return isControlled ? props.value : selfValue;
    }, [isControlled, selfValue, props.value]);
    const styles = useSpring({
        transform: focus ? 'scale(1, 1)' : 'scale(1.2, 1.5)',
        duration: 50,
        config: springConfig,
    });
    return (React.createElement(Container, { size: size, "data-role": "input", focus: focus, style: style, className: cx('input', className) },
        prefix && (React.createElement("span", { className: "input-icon", "data-role": "input-icon" }, prefix)),
        React.createElement(animated.div, { "data-role": "input-effect", className: "input-effect", style: styles }),
        React.createElement("input", Object.assign({}, props, { value: controlledValue, className: "input-input", "data-role": "input-input", onFocus: () => {
                setFocus(true);
            }, onBlur: () => setFocus(false), onChange: handleChange }))));
};
